module.exports = __webpack_public_path__ + "img/young-banner.babdfbab.png";